// Funktionsschalter der Vorgänge (#489) – app_settings 'vorgaenge_funktionen' (jsonb).
// Vorgabe Patrick 17.10.2026: jede Funktion wird in der Oberfläche erklärt und ist einzeln
// ein-/ausschaltbar. Fehlt ein Schlüssel, ist die Funktion AUS. Ändern dürfen nur Admins (RLS).
import { supabase } from '../supabase/client';

export const FUNKTIONEN_KEY = 'vorgaenge_funktionen';

export type FunktionKey = 'erkennung' | 'startkarte' | 'nachfrage';

export interface Funktion {
  key: FunktionKey;
  titel: string;
  erklaerung: string;
  /** Was die Funktion ausdrücklich NICHT tut */
  nicht: string;
  /** false = noch nicht gebaut, Schalter gesperrt */
  verfuegbar: boolean;
  etappe: string;
}

export const FUNKTIONEN: readonly Funktion[] = [
  {
    key: 'erkennung', etappe: 'V2', verfuegbar: true,
    titel: 'Vorgänge in neuen Mails erkennen',
    erklaerung: 'Die KI-Analyse prüft jede neue Mail gegen die aktiven Vorgangsarten. Passt eine eindeutig, merkt sie sich die Vorgangsart und die Angaben, die schon in der Mail stehen (z. B. Auszugstermin, Fotos, Zählerstand). Antwortet der Absender in einem laufenden Vorgang, werden neue Angaben automatisch im Ticket nachgetragen (schon erfasste bleiben unverändert).',
    nicht: 'Legt kein Ticket an und schickt keine Antwort – sie bereitet nur den Vorschlag vor. Ausgeschaltet läuft die Analyse wie bisher.',
  },
  {
    key: 'startkarte', etappe: 'V3', verfuegbar: true,
    titel: 'Vorgang aus der Mail starten',
    erklaerung: 'In der Mail erscheint die Karte „Vorgang starten“: Angaben (vorhanden / fehlt), Antwortentwurf mit Rückfragen, Checkliste und Frist. Ein Klick legt das Ticket an.',
    nicht: 'Versendet nichts ohne Freigabe.',
  },
  {
    key: 'nachfrage', etappe: 'V5', verfuegbar: true,
    titel: 'Nachfragen beantworten und eskalieren',
    erklaerung: 'Bei „Gibt es etwas Neues?“ schlägt die App eine Antwort mit dem letzten Stand des Vorgangs vor. Bei der 2. Nachfrage innerhalb von 14 Tagen wird das Ticket eskaliert und die zuständige Person benachrichtigt.',
    nicht: 'Versendet nichts ohne Freigabe.',
  },
];

export type Schalter = Record<FunktionKey, boolean>;

/** Gespeicherten Wert lesen: nur ausdrücklich true ist an. */
export function leseSchalter(wert: unknown): Schalter {
  const o = wert && typeof wert === 'object' && !Array.isArray(wert) ? wert as Record<string, unknown> : {};
  return { erkennung: o.erkennung === true, startkarte: o.startkarte === true, nachfrage: o.nachfrage === true };
}

export async function ladeSchalter(): Promise<Schalter> {
  const { data, error } = await supabase.from('app_settings').select('value').eq('key', FUNKTIONEN_KEY).maybeSingle();
  if (error) throw error;
  return leseSchalter(data?.value);
}

export async function speichereSchalter(s: Schalter): Promise<void> {
  const { error } = await supabase.from('app_settings').upsert(
    { key: FUNKTIONEN_KEY, value: s, updated_at: new Date().toISOString() },
    { onConflict: 'key' },
  );
  if (error) throw error;
}
